var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left pb-1"
  }, [_c('p', {
    staticClass: "text-left text-2xl font-bold mb-12"
  }, [_vm._v(_vm._s(_vm.$t('address.add.title')))]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('address.add.addressLabel'),
      "placeholder": _vm.$t('address.add.addressLabelPlaceholder')
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('address.add.senderName'),
      "placeholder": _vm.$t('address.add.senderNamePlaceholder')
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('address.add.phone'),
      "placeholder": _vm.$t('address.add.phonePlaceholder')
    },
    on: {
      "keypress": _vm.numbersOnly
    },
    model: {
      value: _vm.phoneNumber,
      callback: function callback($$v) {
        _vm.phoneNumber = $$v;
      },
      expression: "phoneNumber"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-4 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('address.add.selectIcon')))]), _c('div', {
    staticClass: "flex items-center gap-2 mdmax:flex-wrap"
  }, _vm._l(_vm.iconsName, function (icon, index) {
    return _c('div', {
      key: 'icon' + index,
      staticClass: "p-2 cursor-pointer rounded-md",
      class: [_vm.selectedIcon === icon ? 'bg-primary-100' : 'bg-neutral-200'],
      on: {
        "click": function click($event) {
          return _vm.selectIcon(icon);
        }
      }
    }, [_c('img', {
      staticClass: "h-6 w-6",
      attrs: {
        "src": _vm.iconsMapping[icon]
      }
    })]);
  }), 0)]), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('address.add.searchAddress')))]), _c('div', {
    staticClass: "relative",
    attrs: {
      "id": "city-search-container"
    }
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('address.add.searchAddress')
    },
    on: {
      "input": function input($event) {
        return _vm.searchCity($event, 'destination');
      },
      "focus": function focus($event) {
        _vm.visibleSuggestion = true;
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function callback($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion ? _c('div', {
    staticClass: "mt-1 z-50 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'destination');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('address.add.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('address.add.mapLocation')))]), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "absolute top-2 left-2 right-2 z-10"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.placeSearch,
      expression: "placeSearch"
    }],
    staticClass: "w-full px-4 py-2 pr-10 rounded-lg border border-neutral-300 bg-white shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('address.add.searchLocation')
    },
    domProps: {
      "value": _vm.placeSearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.placeSearch = $event.target.value;
      }, _vm.searchPlaces],
      "focus": function focus($event) {
        _vm.showPlaceSuggestions = true;
      }
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search', {
    staticClass: "w-5 h-5 text-neutral-400"
  })], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showPlaceSuggestions && _vm.placeSuggestions.length > 0 ? _c('div', {
    staticClass: "absolute top-full mt-1 w-full bg-white rounded-lg shadow-lg border border-neutral-200 max-h-60 overflow-y-auto z-50"
  }, _vm._l(_vm.placeSuggestions, function (place, index) {
    return _c('div', {
      key: index,
      staticClass: "px-4 py-3 hover:bg-neutral-50 cursor-pointer border-b border-neutral-100 last:border-b-0",
      on: {
        "click": function click($event) {
          return _vm.selectPlace(place);
        }
      }
    }, [_c('div', {
      staticClass: "text-sm font-medium text-neutral-900"
    }, [_vm._v(_vm._s(place.description))])]);
  }), 0) : _vm._e()])], 1)]), _c('GmapMap', {
    staticClass: "w-full h-64 rounded-lg overflow-hidden border border-neutral-300",
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: true,
        streetViewControl: false,
        fullscreenControl: true
      }
    },
    on: {
      "click": _vm.updateMarkerPosition
    }
  }, [_c('GmapMarker', {
    attrs: {
      "position": _vm.mapCenter,
      "draggable": true
    },
    on: {
      "dragend": _vm.updateMarkerPosition
    }
  })], 1), _c('button', {
    staticClass: "mt-3 w-full flex items-center justify-center gap-2 text-white px-4 py-2 rounded-lg shadow-lg font-medium transition-colors disabled:opacity-70",
    staticStyle: {
      "background-color": "#61d7d0"
    },
    attrs: {
      "disabled": _vm.isConfirmingLocation
    },
    on: {
      "click": _vm.confirmLocation
    }
  }, [!_vm.isConfirmingLocation ? _c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    }
  })]) : _c('svg', {
    staticClass: "animate-spin h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "4"
    }
  }), _c('path', {
    staticClass: "opacity-75",
    attrs: {
      "fill": "currentColor",
      "d": "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }
  })]), _vm._v(" " + _vm._s(_vm.isConfirmingLocation ? _vm.$t('address.add.loading') : _vm.$t('address.add.selectLocation')) + " ")]), _c('div', {
    staticClass: "mt-2 text-sm text-neutral-600"
  }, [_c('span', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s(_vm.$t('address.add.coordinates')) + ":")]), _vm._v(" " + _vm._s(_vm.mapCenter.lat.toFixed(6)) + ", " + _vm._s(_vm.mapCenter.lng.toFixed(6)) + " ")])], 1)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "label": _vm.$t('address.add.address'),
      "placeholder": _vm.$t('address.add.addressPlaceholder')
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "label": _vm.$t('address.add.detailAddress'),
      "placeholder": _vm.$t('address.add.detailAddressPlaceholder')
    },
    model: {
      value: _vm.addressDetail,
      callback: function callback($$v) {
        _vm.addressDetail = $$v;
      },
      expression: "addressDetail"
    }
  })], 1), _c('div', {
    staticClass: "mb-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.is_main,
      expression: "is_main"
    }],
    staticClass: "styled-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "main-address",
      "id": "main-address"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_main) ? _vm._i(_vm.is_main, null) > -1 : _vm.is_main
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.is_main,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.is_main = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.is_main = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.is_main = $$c;
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "main-address"
    }
  }, [_vm._v(_vm._s(_vm.$t('address.add.mainAddress')))])]), _c('div', {
    staticClass: "flex items-center gap-3 mdmax:flex-col",
    class: [_vm.isEditMode ? 'justify-between' : 'justify-end']
  }, [_vm.isEditMode ? _c('div', {
    staticClass: "mdmax:w-full mdmax:order-2"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.delete'),
      "size": _vm.isMobile ? 'full' : 'regular',
      "type": "delete_outline",
      "icon": function icon() {
        return import('@/components/Icons/Trash');
      }
    },
    on: {
      "action": function action($event) {
        return _vm.toggleConfirmModal('delete');
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex items-center gap-3 justify-end mdmax:order-1 mdmax:w-full"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.cancel'),
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.closeModal();
      }
    }
  }), !_vm.isEditMode ? _c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.save'),
      "disabled": _vm.isDisabled,
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.save();
      }
    }
  }) : _c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.update'),
      "disabled": _vm.isDisabled,
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleConfirmModal('save');
      }
    }
  })], 1)]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleConfirmModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.$t('address.add.confirmation')))]), _vm.confirmationAction === 'save' ? _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('address.add.confirmUpdate')) + " ")]) : _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('address.add.confirmDelete')) + " ")])])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.no'),
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }), _vm.confirmationAction === 'save' ? _c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.yes'),
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.save();
      }
    }
  }) : _c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.add.yes'),
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.deleteAddress();
      }
    }
  })], 1)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }